
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class FactIndexRorGrid extends SiteEntityGrid<FactIndexRorRow, any> {
        protected getColumnsKey() { return FactIndexRorColumns.columnsKey; }
        protected getDialogType() { return FactIndexRorDialog; }
        protected getIdProperty() { return FactIndexRorRow.idProperty; }
        protected getInsertPermission() { return FactIndexRorRow.insertPermission; }
        protected getLocalTextPrefix() { return FactIndexRorRow.localTextPrefix; }
        protected getService() { return FactIndexRorService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}